<template>
  <span v-if="!url" @click="(e) => handleClick(e)">
    <slot />
  </span>
  <router-link
    v-else-if="isInternal"
    v-slot="{ href, navigate, isActive, isExactActive }"
    :to="relativeUrl"
    :class="bemBlock"
  >
    <a
      :href="href"
      :class="{
        'router-link-active': isActive,
        'router-link-exact-active': isExactActive,
      }"
      @click="(e) => handleClick(e, navigate)"
    ><slot /></a>
  </router-link>
  <a
    v-else
    target="_blank"
    :href="url"
    :class="bemBlock"
    @click="(e) => handleClick(e)"
  >
    <slot />
  </a>
</template>

<script>
import bemClassesMixin from '../mixins/bemClassesMixin';
import { parseRelativeUrl } from '../../common/utils/url';

export default {
  name: 'BaseLink',

  mixins: [bemClassesMixin],

  props: {
    url: {
      type: String,
      default: null,
      required: false,
    },
    type: {
      type: String,
      default: 'internal',
      required: false,
      validator: (prop) =>
        ['product', 'category', 'internal', 'external'].some(
          (type) => prop === type
        ),
    },
    ID: {
      // eslint-disable-line vue/prop-name-casing
      type: [String, Number],
      default: null,
      required: false,
    },
  },

  computed: {
    relativeUrl() {
      if (this.isInternal) {
        return parseRelativeUrl(this.url);
      }
      return this.url;
    },
    isInternal() {
      return ['product', 'category', 'internal'].includes(this.type);
    },
  },

  methods: {
    /**
     * Handles click events across all link types (span, router-link, anchor).
     * Emits a 'click' event to the parent and optionally triggers router
     * navigation.
     *
     * @param {MouseEvent} e - The native click event.
     * @param {Function} [navigate] - Optional navigate function provided by
     *  router-link's v-slot API. Only present when the link is an internal
     *  router-link.
     */
    handleClick(e, navigate) {
      this.$emit('click', e);
      if (navigate) navigate(e);
    },
  },
};
</script>
